import { defineMessages } from 'react-intl';

export const userMessages = defineMessages({
    user: {
        id: 'user',
        defaultMessage: 'User',
    },
    users: {
        id: 'users',
        defaultMessage: 'Users',
    },
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    username: {
        id: 'username',
        defaultMessage: 'Username',
    },
    email: {
        id: 'email',
        defaultMessage: 'Email',
    },
    active: {
        id: 'active',
        defaultMessage: 'Active',
    },
    roles: {
        id: 'roles',
        defaultMessage: 'Roles',
    },
    dateJoined: {
        id: 'date-joined',
        defaultMessage: 'Date joined',
    },
    password: {
        id: 'password',
        defaultMessage: 'Password',
    },
    confirmPassword: {
        id: 'confirm-password',
        defaultMessage: 'Confirm password',
    },
    createUserSuccess: {
        id: 'create-user-success',
        defaultMessage: 'User created',
    },
    updateUserSuccess: {
        id: 'update-user-success',
        defaultMessage: 'User updated',
    },
    createUserSuccessDescription: {
        id: 'create-user-success-description',
        defaultMessage: 'User {entry} has been successfully created.',
    },
    updateUserSuccessDescription: {
        id: 'update-user-success-description',
        defaultMessage: 'User {entry} has been successfully updated.',
    },
    addUser: {
        id: 'add-user',
        defaultMessage: 'Add user',
    },
    addUserSubtitle: {
        id: 'add-user-subtitle',
        defaultMessage: 'Add new user',
    },
    editUserSubtitle: {
        id: 'edit-user-subtitle',
        defaultMessage: 'Edit user {entry}',
    },
    changePassword: {
        id: 'change-password',
        defaultMessage: 'Change password',
    },
    changePasswordSubtitle: {
        id: 'change-password-subtitle',
        defaultMessage: 'Change password of user {entry}',
    },
    changePasswordSuccess: {
        id: 'change-password-success',
        defaultMessage: 'User password changed',
    },
    changePasswordSuccessDescription: {
        id: 'change-password-success-description',
        defaultMessage: 'The user password has been successfully changed.',
    },
    activateUser: {
        id: 'activate-user',
        defaultMessage: 'Activate user',
    },
    activateUserSubtitle: {
        id: 'activate-user-subtitle',
        defaultMessage: 'Activate user {entry}',
    },
    confirmActivateUser: {
        id: 'confirm-activate-user',
        defaultMessage: 'Are you sure you want to activate user {entry}?',
    },
    userActivationSuccess: {
        id: 'user-activation-success',
        defaultMessage: 'The user was activated',
    },
    userActivationSuccessDescription: {
        id: 'user-activation-success-description',
        defaultMessage: 'The user {entry} was successfully activated.',
    },
    deactivateUser: {
        id: 'deactivate-user',
        defaultMessage: 'Deactivate user',
    },
    deactivateUserSubtitle: {
        id: 'deactivate-user-subtitle',
        defaultMessage: 'Deactivate user {entry}',
    },
    confirmDeactivateUser: {
        id: 'confirm-deactivate-user',
        defaultMessage: 'Are you sure you want to deactivate user {entry}?',
    },
    userDeactivationSuccess: {
        id: 'user-deactivation-success',
        defaultMessage: 'The user was deactivated',
    },
    userDeactivationSuccessDescription: {
        id: 'user-deactivation-success-description',
        defaultMessage: 'The user {entry} was successfully deactivated.',
    },
    searchUser: {
        id: 'search-user',
        defaultMessage: 'Search user',
    },
    noUser: {
        id: 'no-user',
        defaultMessage: 'No user',
    },
    noUserFound: {
        id: 'no-user-found',
        defaultMessage: 'No user found',
    },
});
